export const PORTFOLIO_TEMPLATE = `portfolio_plan_id,name,family_path,organization,base_permission,ticker,sleeve_plan_id,allocation_id,weight,tag,tag,asset_class_name,asset_class_category
AIP_FAR_CUSTOMABC1,ABC Custom Model,,Farther,Private,SPY,,,60.00%,,,,
AIP_FAR_CUSTOMABC1,ABC Custom Model,,Farther,Private,AGG,,,38.00%,,,,
AIP_FAR_CUSTOMABC1,ABC Custom Model,,Farther,Private,US Dollars,,,2.00%,,,,`;
